"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var definitions_1 = require("./definitions");
var filter_1 = require("./filter");
var functions_1 = require("./functions");
/**
 * =============================================================================
 * CompoundFilter holds multipple other filters
 * =============================================================================
 */
var CompoundFilter = /** @class */function (_super) {
  __extends(CompoundFilter, _super);
  function CompoundFilter(operator) {
    var _this = _super.call(this) || this;
    _this.operator = operator;
    // Holds the compounds children
    _this.queries = [];
    return _this;
  }
  /**
   * Get the operator. No setter available. Use constructor. Changing AND to OR at runtime seemed unnecessary
   */
  CompoundFilter.prototype.getOperator = function () {
    return this.operator;
  };
  /**
   * Change the operator of this filter
   * @param operator
   */
  CompoundFilter.prototype.setOperator = function (operator) {
    this.operator = operator;
    return this;
  };
  /**
   * Add another child filter condition to this filter
   * @param child Filter to be added as a child.
   * @param silent Do not notify subscriptions of onFilterChanged
   */
  CompoundFilter.prototype.addFilter = function (filter, replaceFn, silent) {
    var _this = this;
    var childrenToRemove = replaceFn ? this.queries.filter(function (child) {
      return replaceFn(child.filter, filter);
    }) : [];
    if (childrenToRemove.length === 0) {
      this.add(filter, silent);
    } else {
      childrenToRemove.forEach(function (child) {
        _this.removeFilter(child.filter, true);
      });
      this.add(filter, silent);
    }
    return this;
  };
  /**
   * Add another child filter condition to this filter
   * @param filter Filter to be added as a child.
   * @param silent Do not notify subscriptions of onFilterChanged
   */
  CompoundFilter.prototype.add = function (filter, silent) {
    var _this = this;
    this.queries.push({
      filter: filter,
      sub: filter.onChanged(function (changedFilter) {
        _this.updated.next(changedFilter);
      })
    });
    if (!silent) {
      this.updated.next(this);
    }
  };
  /**
   * Remove a child filter from this CompoundFilter
   * @param filter Filter to be removed from the children. Must be an object Match!
   * @param silent Do not notify subscriptions of onFilterChanged
   */
  CompoundFilter.prototype.removeFilter = function (filter, silent) {
    var count = this.queries.length;
    // remove child if already exist
    this.queries = this.queries.filter(function (query) {
      var keep = query.filter !== filter;
      if (!keep) {
        query.sub.unsubscribe();
      }
      return keep;
    });
    if (!silent && this.queries.length < count) {
      this.updated.next(this);
    } else if (this.queries.length === count) {
      throw new Error('Cannot remove a filter that is not a child of this Compound. Make sure you have the right reference or use removeFilters()');
    }
    return this;
  };
  /**
   * Remove a child filter from this CompoundFilter
   * @param filter Filter to be removed from the children. Must be an object Match!
   * @param silent Do not notify subscriptions of onFilterChanged
   */
  CompoundFilter.prototype.removeFilters = function (removeFn, silent) {
    var count = this.queries.length;
    // remove child if already exist
    this.queries = this.queries.filter(function (query) {
      var keep = !removeFn(query.filter);
      if (!keep) {
        query.sub.unsubscribe();
      }
      return keep;
    });
    if (!silent && this.queries.length < count) {
      this.updated.next(this);
    } else if (this.queries.length === count) {
      console.warn('removeFilters did not remove any filters.');
    }
    return this;
  };
  /**
   * Get the child queries of this CompoundFilter
   * @return     Array<Filter> The child filters
   */
  CompoundFilter.prototype.getQueries = function () {
    return this.queries.map(function (queries) {
      return queries.filter;
    });
  };
  /**
   * Find a child query based on ID
   * @return    Filter or undefined if not found
   */
  CompoundFilter.prototype.getQuery = function (id) {
    return this.findQuery(functions_1.findById(id));
  };
  /**
   * Find a child query based on ID
   * @return    Filter or undefined if not found
   */
  CompoundFilter.prototype.findQuery = function (findFunc) {
    var match = this.queries.find(function (query) {
      return findFunc(query.filter);
    });
    return match ? match.filter : undefined;
  };
  /**
   * Convert this filter object to a plain JSON object in IqlCompoundQuery format
   * @return     JSON<IqlCompoundQuery>
   */
  CompoundFilter.prototype.toJson = function (clean) {
    if (clean === void 0) {
      clean = false;
    }
    var filterJson = __assign({}, _super.prototype.toJson.call(this, clean), {
      operator: this.operator,
      queries: this.queries.map(function (term) {
        return term.filter.toJson(clean);
      }).filter(function (term) {
        return !!term;
      })
    });
    // if clean and no queries, return undefined instead
    if (clean && !filterJson.queries.length) {
      return undefined;
    }
    return filterJson;
  };
  /**
   * Convert this filter object to a plain query string format
   * @return     string
   */
  CompoundFilter.prototype.toQueryString = function () {
    var sort = _super.prototype.toQueryString.call(this);
    var op = this.operator === definitions_1.IqlQueryOperator.AND ? 'i' : 'u';
    var id = this.getIdentifier() || '';
    var q = this.queries.map(function (term) {
      return term.filter.toQueryString();
    }).filter(function (term) {
      return !!term;
    }).join(definitions_1.valueSeparator);
    return "" + (this.exclude ? definitions_1.filterNegate : '') + op + definitions_1.filterControl + id + definitions_1.filterControl + sort + definitions_1.compoundBegin + q + definitions_1.compoundEnd;
  };
  /**
   * Convert this filter object to a Human readable format
   * @return     string
   */
  CompoundFilter.prototype.toHumanReadable = function () {
    var q = this.queries.map(function (term) {
      return term.filter.toHumanReadable();
    }).join(" " + this.operator + " ");
    var id = this.getIdentifier() ? " " + definitions_1.HRfilterID + " " + this.getIdentifier() : '';
    return "" + (this.getExclude() ? definitions_1.HRfilterNegate : '') + definitions_1.compoundBegin + q + definitions_1.compoundEnd + _super.prototype.toHumanReadable.call(this) + id;
  };
  /**
   * Clones the CopoundFilter
   * @return CompoundFilter
   */
  CompoundFilter.prototype.clone = function () {
    var clone = new CompoundFilter(this.operator).setIdentifier(this.getIdentifier()).setExclude(this.getExclude()).setSort(this.getSort());
    this.queries.forEach(function (term) {
      clone.addFilter(term.filter.clone());
    });
    return clone;
  };
  CompoundFilter.prototype.equals = function (other, ignoreSort) {
    if (ignoreSort === void 0) {
      ignoreSort = false;
    }
    // Make sure the other is a COMPOUND as well
    if (!other.queries) {
      return false;
    }
    // Check all the basics
    if (!_super.prototype.equals.call(this, other, ignoreSort)) {
      return false;
    }
    // Make sure we look at the same operator
    if (this.getOperator() !== other.getOperator()) {
      return false;
    }
    // now for all our childQueries, we need to make sure we map them correctly despite the order!
    if (this.getQueries().length !== other.getQueries().length) {
      return false;
    }
    // for every one of our queries, find if ONE in the other array that equals
    var theirs = other.getQueries().slice(); // will be modified;
    return this.getQueries().reduce(function (result, query) {
      var hit = theirs.findIndex(function (otherQuery) {
        return query.equals(otherQuery, ignoreSort);
      });
      if (hit > -1) {
        theirs.splice(hit, 1);
        return result;
      }
      return false;
    }, true);
  };
  return CompoundFilter;
}(filter_1.Filter);
exports.CompoundFilter = CompoundFilter;